export * from 'roles/constants/roles_constants';



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/constants/index.js